import { PspContext } from "@/config/contexts";
import { Dispatch, SetStateAction, useContext } from "react";
import { MfaSetupContext } from "../../useMfaSetup";

type UseMfaSelectMethodParams = {
  onBack: () => void;
  setMfaSetupContext: Dispatch<SetStateAction<MfaSetupContext>>;
};

export function useMfaSelectMethod({
  onBack,
  setMfaSetupContext,
}: UseMfaSelectMethodParams) {
  const { lang } = useContext(PspContext);

  function onBackWrapper() {
    setMfaSetupContext((prev) => ({ ...prev, chosenMethod: undefined }));
    onBack();
  }

  return { lang, onBackWrapper };
}
